import { createContext } from 'react';
import type { ControlClientMessage } from 'src/contracts';

export interface WebSocketContext {
    sendMessage: (message: ControlClientMessage) => boolean;
    connected: boolean;
}

export const WebSocketContext = createContext<WebSocketContext | null>(null);
